import { ListItem } from "arkh";
import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import {
  TaskTypeIcon,
  TaskTypeIconOptions,
  TaskTypeIconSize,
} from "../types/TaskTypeIcon";
import { TaskListItemIcon_Task$key } from "./__generated__/TaskListItemIcon_Task.graphql";
import { TaskListItemTitle_Task$key } from "./__generated__/TaskListItemTitle_Task.graphql";

export function TaskListItemIcon(props: { task: TaskListItemIcon_Task$key }) {
  const data = useFragment(
    graphql`
      fragment TaskListItemIcon_Task on Task {
        __typename
        ... on TaskNumber {
          unit
        }
        ... on TaskCheck {
          sentiments
        }
        ... on TaskText {
          __typename
        }
      }
    `,
    props.task
  );

  const type = useMemo(() => {
    if (data.__typename === "TaskCheck") {
      return {
        __typename: "TaskCheck",
        sentiments: data.sentiments,
      } as TaskTypeIconOptions;
    }
    if (data.__typename === "TaskNumber") {
      return {
        __typename: "TaskNumber",
        unit: data.unit,
      } as TaskTypeIconOptions;
    }
    if (data.__typename === "TaskText") {
      return {
        __typename: "TaskText",
      } as TaskTypeIconOptions;
    }
    throw Error("");
  }, [data]);

  return <TaskTypeIcon size={TaskTypeIconSize.SMALL} type={type} />;
}

export function TaskListItemTitle(props: { task: TaskListItemTitle_Task$key }) {
  const data = useFragment(
    graphql`
      fragment TaskListItemTitle_Task on Task {
        title
      }
    `,
    props.task
  );

  return <ListItem.Title>{data.title}</ListItem.Title>;
}
